const CONSOLE_URL = (process.env.REACT_APP_CONSOLE_URL || "https://console.stayeasy.io").replace(/\/$/, "");

export default function HostSubscriptionCancelled() {
  return (
    <main className="mx-auto max-w-3xl px-5 py-24 text-center md:px-10 md:py-32">
      <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Host subscription</p>
      <h1 className="mt-4 font-display text-5xl font-medium tracking-tight">Payment was cancelled.</h1>
      <p className="mx-auto mt-5 max-w-xl text-muted-foreground">Your host account is already saved. Continue from your host console to choose a plan or restart Stripe checkout without registering again.</p>
      <a href={`${CONSOLE_URL}/host/subscription`} className="mt-8 inline-flex rounded-full bg-foreground px-6 py-3 text-sm font-medium text-background">Continue host setup</a>
    </main>
  );
}
